import type { CertificationModule } from "@brookbush/types";

import { useRouter } from "next/compat/router";
import useSWR, { type SWRResponse } from "swr";

import useCertification from "./useCertification";

const useCertificationModule = () => {
	const { certification } = useCertification();
	const { moduleSlug } = (useRouter()?.query ?? {}) as { moduleSlug: string };

	const { data: module, ...rest } = useSWR(
		moduleSlug && `/certifications/${certification.slug}/modules/${moduleSlug}`,
	) as SWRResponse<CertificationModule> & {
		data: CertificationModule;
	};

	return {
		module,
		...rest,
	};
};

export default useCertificationModule;
